// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.cobrand-logos {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  height: 31px;
}
.cobrand-logos .club-logo {
  width: 32px;
  height: 31px;
  flex-shrink: 0;
}
.cobrand-logos .divider {
  width: 1px;
  height: 29px;
  background: #ffffff;
}
.cobrand-logos .amex-logo {
  width: 103px;
  height: auto;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/cobrand-logos/cobrand-logos.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AACJ;AAEE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAGE;EACE,YAAA;EACA,YAAA;EACA,cAAA;AADJ","sourcesContent":[":host {\n  display: block;\n}\n\n.cobrand-logos {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  height: 31px;\n\n  .club-logo {\n    width: 32px;\n    height: 31px;\n    flex-shrink: 0;\n  }\n\n  .divider {\n    width: 1px;\n    height: 29px;\n    background: #ffffff;\n  }\n\n  .amex-logo {\n    width: 103px;\n    height: auto;\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
